import { EvtHeader } from "components/header";
import ClientForm from "@/modules/crm/clients/crud/form";
import React from "react";
import { useParams } from "react-router-dom";

const UpdateClient = () => {
  const { clientId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Client" />
      <div className="p-6 max-w-2xl">
        <ClientForm clientId={clientId} />
      </div>
    </div>
  );
};

export default UpdateClient;
